<template>
    <div class="AllBox">
        <van-sticky>
            <van-nav-bar fixed title="群名片" left-arrow safe-area-inset-top @click-left="onClickLeft">
                <template #left>
                    <div class="left-nr">
                        <img src="../../assets/nav/yz_nav_fh.png" alt="">
                    </div>
                </template>
            </van-nav-bar>
        </van-sticky>

        <div class="useInfo">
            <img :src="state.userAvatar" alt="">
        </div>
        <div class="controlUser">

            <div class="nickName">
                <p>群昵称</p>
                <div class="resetNickname" @click="goResetNick">
                    <p>{{state.userNickName}}</p>
                    <img src="../../assets/chat/chat_group_go.png" alt="">
                </div>
            </div>

            <div class="settingUser">
                <div v-if="state.typeOwner" class="set">
                    <p>设置管理员</p>
                    <p>
                        <van-switch v-model="state.isManager" active-color="#664FC3" inactive-color="#dcdee0" size="22px" @click="setManager"/>
                    </p>
                </div>
                <div class="set">
                    <p>设置禁言</p>
                    <p>
                        <van-switch v-model="state.isNoSpeaking" active-color="#664FC3" inactive-color="#dcdee0" size="22px" @click="setSpeaking"/>
                    </p>
                </div>
            </div>
        </div>

        <div class="removeOut" @click="removeUserOut">
            <p>移出本群</p>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { onMounted ,reactive,onActivated  } from 'vue';
import SDK from "@yxim/nim-web-sdk";
import { onDeactivated } from 'vue';
import { Toast } from 'vant';
import { GroupWyKick } from '@/api/chat'
export default {
    name: 'GroupMemberInfo',
    setup() {
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const state = reactive({
            userTeamId: '',
            userAccount: '',
            nim:null,

            // 被查询者信息
            userNickName:'',
            userAvatar:'',
            userType:'',

            // 查询者权限
            myType:'',
            // 查询者账号   默认为ceshi2，后期根据登录者账号获取
            myAccount:store.state.wyAccount,

            // 是否显示设置管理员
            typeOwner:false,

            // 是否为管理员
            isManager:false,
            // 是否禁言
            isNoSpeaking:false,

            nickName:''
        })

    onActivated(() => {
        // console.log('群成员信息--------',route.query)
        state.userTeamId=route.query.teamId
        state.userAccount=route.query.account

        // 初始化云信
        state.nim=SDK.NIM.getInstance({
            debug: true,
            appKey: store.state.appKey,
            account:store.state.wyAccount,
            token:store.state.wyToken,
            debugLevel:"debug",
            db: false,
        })

        // 获取用户信息
        getUserInfo()

        // 获取本账号权限
        state.nim.getTeamMemberByTeamIdAndAccount({
            teamId:state.userTeamId,
            account:state.myAccount,
            done: getMyTypeDone
        });
    })
    // 离开时清空信息
    onDeactivated(()=>{
        state.userNickName=''
        state.userAvatar=''
        state.userType=''
        state.myType=''
        state.typeOwner=false
        state.isManager=false
        state.isNoSpeaking=false
    })

    const getMyTypeDone = (error, user) => {
        if (error) {
            // console.log('获取本账号权限', error);
            return;
        }
        // console.log('获取本账号权限----------', user);
        state.myType=user[state.myAccount].type
        if(state.myType=='owner'){
            state.typeOwner=true
        }
    }

    const onClickLeft = () => {
                router.go(-1);
     };

         
    const getUserInfo = () => {
        // console.log('获取被查看用户群组信息')
        state.nim.getTeamMemberByTeamIdAndAccount({
            teamId:state.userTeamId,
            account:state.userAccount,
            done: getTeamMemberDone
        });

        state.nim.getUser({
            account:state.userAccount,
            done: getUserDone
        })
    } 
    const getTeamMemberDone = (error, user) => {
        if (error) {
            // console.log('获取被查看用户群组信息', error);
            return;
        }
        // console.log('获取被查看用户群组信息', user);
        if(user[state.userAccount].nickInTeam){
            state.userNickName=user[state.userAccount].nickInTeam
        }else{
            // state.userNickName=user[state.userAccount].account
            state.userNickName=state.nickName
        }

        // 判断是否为管理员
        if(user[state.userAccount].type=="manager"){
            state.isManager=true
        }else{
            state.isManager=false
        }
        // 判断是否禁言
        if(user[state.userAccount].mute){
            state.isNoSpeaking=true
        }else{
            state.isNoSpeaking=false
        }
    }
    const getUserDone = (error, user) => {
        if (error) {
            // console.log('获取被查看用户个人信息', error);
            return;
        }
        // console.log('获取被查看用户个人信息', user);
        state.userAvatar=user.avatar
        state.nickName=user.nick
    }

    // 设置为管理员
    const setManager = () => {
        // console.log('设置为管理员')
        state.isManager==!state.isManager
        console.log(state.isManager)

        // 如果值为true，则设置为管理员，反之取消管理员
        if(state.isManager){
            state.nim.addTeamManagers({
                teamId:state.userTeamId,
                accounts:[state.userAccount],
                done: addTeamManagersDone
            });
        }else{
            state.nim.removeTeamManagers({
                teamId:state.userTeamId,
                accounts:[state.userAccount],
                done: removeTeamManagersDone
            });
        }
    }
    // 添加管理员的回调
    const addTeamManagersDone = (error, obj) => {
        if (error) {
            console.log('添加管理员失败', error);
            Toast('添加管理员失败')
            return;
        }
        console.log('添加管理员成功', obj);
        Toast('添加管理员成功')
    }
    // 移除管理员的回调
    const removeTeamManagersDone = (error, obj) => {
        if (error) {
            console.log('移除管理员失败', error);
            Toast('移除管理员失败')
            return;
        }
        console.log('移除管理员成功', obj);
        Toast('移除管理员成功')
    }


    // 设置禁言
    const setSpeaking = () => {
        console.log('设置禁言')
        state.isNoSpeaking==!state.isNoSpeaking
        console.log(state.isNoSpeaking)
        state.nim.updateMuteStateInTeam({
            teamId: state.userTeamId,
            account:state.userAccount,
            mute: state.isNoSpeaking,
            done: updateMuteStateInTeamDone
        })
    }
    // 设置禁言的回调
    const updateMuteStateInTeamDone = (error, obj) => {
        if (error) {
            console.log('设置禁言失败', error);
            if(state.isNoSpeaking){
                Toast('设置禁言失败')
            }else{
                Toast('取消禁言失败')
            }
            return;
        }
        console.log('设置禁言成功', obj);
        if(state.isNoSpeaking){
            Toast('设置禁言成功')
        }else{
            Toast('取消禁言成功')
        }
    }
    // 移出本群
    const removeUserOut = () => {
        console.log('移出本群')
        // state.nim.removeTeamMembers({
        //     teamId: state.userTeamId,
        //     accounts: [state.userAccount],
        //     done: removeTeamMembersDone
        // });
        GroupWyKick({
            groupId:state.userTeamId,
            owner:state.myAccount,
            member:state.userAccount
        }).then(res=>{
            // console.log('踢人出群的结果------',res)
            if(res.data.code=='1'){
                Toast('移出本群成功')
                router.back()
            }
        })

    }
    // 踢人的回调
    const removeTeamMembersDone = (error, obj) => {
        if (error) {
            console.log('移出本群失败', error);
            Toast('移出本群失败')
            return;
        }
        console.log('移出本群成功', obj);
        Toast('移出本群成功')
        // 跳转到群成员列表
        onClickLeft()
    }

    // 更改群昵称
    const goResetNick = () => {
        router.push({
            path: "/ResetGroupName",
            query: { userAccount: state.userAccount, name: state.userNickName, teamId: state.userTeamId },
        });
    }



        return {
            state,
            onClickLeft,
            setManager,
            setSpeaking,
            removeUserOut,
            goResetNick
        }
    }
}
</script>
<style src="../../styles/van-sticky-nav.css"></style>
<style scoped>
.AllBox {
    min-height: 100vh;
    background-color: #f7f7f7;
    padding-top: calc(110px + constant(safe-area-inset-top));
    /* 适配安全区域 iOS < 11.2 */
    padding-top: calc(110px + env(safe-area-inset-top));
    /* 适配安全区域 iOS >= 11.2 */
}
.van-nav-bar{
    background: #f7f7f7 ;
}
.useInfo {
    /* height: 132px; */
    margin-top: 58px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.useInfo img {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    margin-bottom: 24px;
}
.controlUser {
    padding: 0 32px;
    margin-top: 64px;
}
.settingUser,.nickName{
    height: 68px;
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin-bottom: 20px;
}
.controlUser .settingUser{
    display: block;
    padding: 0;
    height: 100%;
}
.controlUser .settingUser .set{
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
    height: 88px;
    padding: 24px;
}


.removeOut{
    padding: 0 32px;
    height:100%;
    width: 100%;
}
.removeOut p{
    height: 88px;
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 64px;
    color: #FF6666;
    font-size: 32px;
    border-radius: 44px;
}

.resetNickname{
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 28px;
}
.resetNickname img{
    width: 36px;
    height: 36px;
}

</style>